import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, LogIn } from "lucide-react";
import Logo from "../components/Logo";
import { SectionBg } from "../components/SectionBg";
import { BG } from "../lib/data";
import { useAuth } from "../lib/auth";
import { useLang } from "../lib/i18n";

export default function Login() {
  const { user, loading, login } = useAuth();
  const { a, lang, setLang } = useLang();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/dashboard", { replace: true });
  }, [user, loading, navigate]);

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden px-5">
      <SectionBg src={BG.contact} opacity={0.35} />
      <div className="relative w-full max-w-md rounded-3xl border border-white/10 bg-panel/80 backdrop-blur-xl p-8 sm:p-10">
        <div className="flex items-center justify-between">
          <Link to="/" data-testid="login-back-home" className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400 hover:text-gold">
            <ArrowLeft size={13} /> Home
          </Link>
          <button data-testid="login-lang-toggle" onClick={() => setLang(lang === "en" ? "te" : "en")} className="rounded-full border border-gold/40 px-3 py-1.5 font-mono text-[10px] text-gold">
            {lang === "en" ? "TE" : "EN"}
          </button>
        </div>
        <div className="mt-8"><Logo /></div>
        <h1 data-testid="login-title" className="font-display font-extrabold text-3xl sm:text-4xl text-white mt-6">{a.login.title}</h1>
        <p className="text-slate-400 text-sm leading-relaxed mt-3">{a.login.sub}</p>
        <button
          data-testid="google-login-button"
          onClick={() => login("/dashboard")}
          className="mt-8 w-full inline-flex items-center justify-center gap-3 rounded-full bg-gold text-ink font-semibold px-6 py-4 hover:bg-white transition-colors"
        >
          <LogIn size={18} /> {a.login.cta}
        </button>
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500 mt-5 text-center">{a.login.admin}</p>
      </div>
    </div>
  );
}
